var React = require('react');

function StatusOnHoldWhiteOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.5 11.5C0.5 5.43323 5.43606 0.5 11.5 0.5C17.5649 0.5 22.5 5.4332 22.5 11.5C22.5 17.5639 17.5648 22.5 11.5 22.5C5.43614 22.5 0.5 17.5639 0.5 11.5Z","fill":"#FF9933","stroke":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.3251 10.613H6.67406C6.43943 10.6132 6.21448 10.7066 6.04857 10.8725C5.88265 11.0384 5.78933 11.2633 5.78906 11.498C5.78906 11.986 6.18706 12.382 6.67406 12.382H16.3251C16.5545 12.3743 16.772 12.2777 16.9315 12.1127C17.0911 11.9476 17.1803 11.727 17.1803 11.4975C17.1803 11.2679 17.0911 11.0473 16.9315 10.8823C16.772 10.7173 16.5545 10.6207 16.3251 10.613","fill":"white","key":1})]);
}

StatusOnHoldWhiteOutline.defaultProps = {"role":"presentation","viewBox":"0 0 23 23","fill":"none"};

module.exports = StatusOnHoldWhiteOutline;

StatusOnHoldWhiteOutline.default = StatusOnHoldWhiteOutline;
